import { IBase } from "src/app/core/models/base";

export interface IFailedImport extends IBase{
    name: string,
    internalNumber: string,
    importFailReason: ImportFailReasons
}

export enum ImportFailReasons {
    Unknown = 0,
    NameDuplicate = 1,
    ProductAndInternalNumberDuplicate = 2
}